import { useState } from 'react';
import { listMaterialLabels } from '@/app/apis';
import type { TagType } from '@/app/types';
import { useElementErrorMsg } from './use-element-error-msg';
import { useExtraTag } from './use-extra-tag';
import { useFetch } from './use-fetch';

export const useLabels = () => {
  const { allTag } = useExtraTag();
  const [selectedTags, setSelectedTags] = useState<string[]>([allTag.id]);
  const [tags, setTags] = useState<TagType[]>();

  const onSelect = (id: string) => {
    const hasAll = selectedTags?.includes(allTag.id);
    if (id === allTag.id) {
      if (hasAll) {
        return; // 只有all时，不可取消all
      }
      setSelectedTags([id]); // 选中 all 时，取消其他选中
    } else {
      if (selectedTags?.includes(id)) {
        // 取消选中
        const temp = selectedTags.filter((it) => it !== id);
        if (!temp.length) {
          temp.push(allTag.id);
        }
        setSelectedTags(temp);
      } else {
        // 选中
        let temp = [...(selectedTags || []), id];

        if (hasAll) {
          temp = temp?.filter((it) => it !== allTag.id) ?? [];
        }
        setSelectedTags(temp);
      }
    }
  };

  const { showErrorMsg } = useElementErrorMsg();

  const { run: getTags } = useFetch(() => listMaterialLabels(), {
    manual: true,
    onSuccess: ({ data, error }) => {
      if (error) {
        showErrorMsg(error);
        setTags([allTag]);
      } else {
        setTags([allTag, ...(data?.labels || [])]);
      }
    },
  });

  const onDelete = (id: string) => {
    if (selectedTags?.includes(id)) {
      const list = selectedTags?.filter((item) => item !== id);
      setSelectedTags(list.length ? list : [allTag.id]);
    }
    setTags(tags?.filter((item) => item.id !== id));
  };

  const selectAll = () => {
    setSelectedTags([allTag.id]);
  };

  return {
    tags, // 所有可用的标签列表
    selectedTags, // 当前选中的标签 ID 列表
    onSelect, // 标签选择处理函数
    getTags, // 获取标签列表的函数
    onDelete, // 删除标签的处理函数
    selectAll, // 选择全部的快捷函数
  };
};
